import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Reassurance } from './components/Reassurance';
import { DamageCheck } from './components/DamageCheck';
import { Process } from './components/Process';
import { Testimonials } from './components/Testimonials';
import { ContactFooter } from './components/ContactFooter';

const App: React.FC = () => {
  const scrollToCheck = () => {
    const element = document.getElementById('schadecheck');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen font-sans text-slate-900 bg-slate-50 selection:bg-brand-100 selection:text-brand-900">
      <Header />
      <main>
        <Hero onScrollToCheck={scrollToCheck} />
        <Reassurance />
        <DamageCheck />
        <Process />
        <Testimonials />
        <ContactFooter />
      </main>
    </div>
  );
};

export default App;